export const categories = [
  { slug: 'shenghuo', name: '生活', icon: 'ri-home-heart-line' },
  { slug: 'meishi', name: '美食', icon: 'ri-restaurant-line' },
  { slug: 'yule', name: '娱乐', icon: 'ri-movie-line' },
  { slug: 'chuangyi', name: '创意', icon: 'ri-lightbulb-flash-line' },
  { slug: 'yinyue', name: '音乐', icon: 'ri-music-line' },
  { slug: 'lvxing', name: '旅行', icon: 'ri-earth-line' },
  { slug: 'keji', name: '科技', icon: 'ri-computer-line' },
  { slug: 'shishang', name: '时尚', icon: 'ri-t-shirt-line' },
];

export const videos = [
  {
    id: 1,
    title: '夏日限定 · 手工蜜桃冰淇淋制作教程',
    category: 'meishi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Homemade%20peach%20ice%20cream%20in%20a%20bright%20summer%20kitchen%2C%20fresh%20ripe%20peaches%20on%20wooden%20table%2C%20soft%20natural%20light%2C%20clean%20minimal%20aesthetic%2C%20warm%20cream%20tones%2C%20food%20photography%20style%20with%20shallow%20depth%20of%20field&width=800&height=450&seq=video-thumb-01&orientation=landscape',
    duration: '03:25',
    views: 128000,
    author: '甜蜜厨房',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20chef%20portrait%2C%20warm%20smile%2C%20clean%20white%20chef%20apron%2C%20soft%20studio%20lighting%2C%20neutral%20cream%20background%2C%20professional%20headshot%20style&width=120&height=120&seq=author-avatar-01&orientation=squarish',
    description: '炎炎夏日，来一份清爽的蜜桃冰淇淋吧！今天教大家用新鲜蜜桃制作口感绵密的意式冰淇淋，无需冰淇淋机，在家也能轻松做出专业级美味。从选桃到成品，每一步都有详细讲解。',
    featured: true,
  },
  {
    id: 2,
    title: '城市漫步｜上海梧桐树下的隐藏咖啡馆',
    category: 'lvxing',
    thumbnail: 'https://readdy.ai/api/search-image?query=Charming%20hidden%20coffee%20shop%20under%20plane%20trees%20on%20Shanghai%20street%2C%20warm%20ambient%20light%2C%20vintage%20decor%2C%20people%20enjoying%20coffee%2C%20golden%20hour%20sunlight%20filtering%20through%20leaves%2C%20cozy%20atmosphere&width=800&height=450&seq=video-thumb-02&orientation=landscape',
    duration: '05:12',
    views: 89000,
    author: '行走的咖啡',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20travel%20blogger%20portrait%2C%20casual%20stylish%20outfit%2C%20friendly%20expression%2C%20warm%20studio%20lighting%2C%20cream%20background&width=120&height=120&seq=author-avatar-02&orientation=squarish',
    description: '在上海法租界的老洋房里，藏着许多不为人知的精品咖啡馆。跟随我们的镜头，一起探索这些充满故事的小店，品味手冲咖啡与城市记忆。',
    featured: true,
  },
  {
    id: 3,
    title: '3分钟学会超治愈的手账排版技巧',
    category: 'chuangyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20bullet%20journal%20spread%20with%20washi%20tape%20and%20stickers%20on%20wooden%20desk%2C%20pens%20and%20brush%20markers%20scattered%20around%2C%20soft%20morning%20light%2C%20aesthetic%20stationery%20flat%20lay%2C%20warm%20cream%20background&width=800&height=450&seq=video-thumb-03&orientation=landscape',
    duration: '02:58',
    views: 256000,
    author: '手账小仙女',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20artist%20portrait%2C%20gentle%20smile%2C%20pastel%20clothing%2C%20creative%20vibe%2C%20soft%20studio%20lighting%2C%20warm%20cream%20background&width=120&height=120&seq=author-avatar-03&orientation=squarish',
    description: '手账新手也能快速上手！本期分享三个超简单的排版方案，让你的手账瞬间变得高级又可爱。学会这些小技巧，每天记录生活都变得更有趣。',
    featured: true,
  },
  {
    id: 4,
    title: '周杰伦《晴天》木吉他指弹翻奏',
    category: 'yinyue',
    thumbnail: 'https://readdy.ai/api/search-image?query=Acoustic%20guitar%20on%20wooden%20stand%20in%20a%20cozy%20room%20with%20warm%20sunset%20light%2C%20music%20notes%20floating%20atmosphere%2C%20minimal%20decor%2C%20artistic%20photography%2C%20cream%20and%20golden%20tones&width=800&height=450&seq=video-thumb-04&orientation=landscape',
    duration: '04:45',
    views: 342000,
    author: '吉他小王子',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20musician%20portrait%2C%20holding%20guitar%2C%20artistic%20look%2C%20warm%20studio%20lighting%2C%20cream%20background&width=120&height=120&seq=author-avatar-04&orientation=squarish',
    description: '经典永远值得被重新演绎。这次为大家带来《晴天》的指弹版本，保留了原曲的温暖感，加入了新的编曲元素。附完整谱子，喜欢的朋友可以练习起来。',
    featured: true,
  },
  {
    id: 5,
    title: '北欧极简风家居改造｜出租屋秒变ins风',
    category: 'shenghuo',
    thumbnail: 'https://readdy.ai/api/search-image?query=Scandinavian%20minimalist%20living%20room%20interior%20with%20warm%20textiles%2C%20plants%2C%20wooden%20furniture%2C%20natural%20light%20from%20large%20window%2C%20cozy%20hygge%20atmosphere%2C%20cream%20and%20beige%20tones&width=800&height=450&seq=video-thumb-05&orientation=landscape',
    duration: '06:30',
    views: 198000,
    author: '家居改造家',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20interior%20designer%20portrait%2C%20modern%20style%2C%20confident%20smile%2C%20warm%20studio%20lighting%2C%20cream%20background&width=120&height=120&seq=author-avatar-05&orientation=squarish',
    description: '预算有限也能打造梦想小家！这次改造花费不超过2000元，从墙面到软装，手把手教你如何把普通出租屋变成温馨舒适的北欧风小窝。',
    featured: false,
  },
  {
    id: 6,
    title: '抖音爆款｜15秒卡点变装全教程',
    category: 'yule',
    thumbnail: 'https://readdy.ai/api/search-image?query=Fashionable%20outfit%20transition%20photography%20concept%2C%20stylish%20clothing%20on%20rack%20with%20warm%20dramatic%20lighting%2C%20fashion%20studio%20vibe%2C%20cream%20and%20peach%20tones%2C%20editorial%20style&width=800&height=450&seq=video-thumb-06&orientation=landscape',
    duration: '01:45',
    views: 567000,
    author: '潮流玩家',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20fashion%20blogger%20portrait%2C%20trendy%20outfit%2C%20cool%20expression%2C%20warm%20studio%20lighting%2C%20cream%20background&width=120&height=120&seq=author-avatar-06&orientation=squarish',
    description: '全网最详细的卡点变装教程来了！从选曲、剪辑到服装搭配，每一步都有详细拆解。掌握这些技巧，你的变装视频也能获得百万播放。',
    featured: false,
  },
  {
    id: 7,
    title: 'AI绘画工具Midjourney进阶技巧大公开',
    category: 'keji',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20art%20generation%20interface%20on%20modern%20computer%20screen%2C%20digital%20art%20display%2C%20warm%20ambient%20desk%20setup%2C%20minimal%20tech%20workspace%2C%20soft%20cream%20and%20golden%20lighting&width=800&height=450&seq=video-thumb-07&orientation=landscape',
    duration: '08:20',
    views: 445000,
    author: '科技猎奇',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20tech%20reviewer%20portrait%2C%20smart%20casual%20look%2C%20friendly%20smile%2C%20warm%20studio%20lighting%2C%20cream%20background&width=120&height=120&seq=author-avatar-07&orientation=squarish',
    description: 'Midjourney V6带来革命性的更新！本期详细解读新版本的提示词技巧、参数设置和风格调教方法，让你轻松生成专业级AI艺术作品。',
    featured: false,
  },
  {
    id: 8,
    title: '2024秋冬穿搭指南｜基础款穿出高级感',
    category: 'shishang',
    thumbnail: 'https://readdy.ai/api/search-image?query=Elegant%20autumn%20winter%20minimalist%20fashion%20outfit%20flat%20lay%20with%20neutral%20tone%20clothing%2C%20wool%20coat%2C%20cashmere%20sweater%2C%20accessories%20on%20cream%20background%2C%20warm%20soft%20lighting%2C%20editorial%20style&width=800&height=450&seq=video-thumb-08&orientation=landscape',
    duration: '05:50',
    views: 312000,
    author: '时尚教主',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20female%20fashion%20stylist%20portrait%2C%20sophisticated%20look%2C%20warm%20smile%2C%20studio%20lighting%2C%20cream%20background&width=120&height=120&seq=author-avatar-08&orientation=squarish',
    description: '基础款不等于无聊！本期分享用衣柜里人人都有的基础单品，搭配出十套高级感十足的冬日造型。不花冤枉钱，也能穿出时尚博主的感觉。',
    featured: false,
  },
  {
    id: 9,
    title: '一人食｜10分钟搞定日式照烧鸡腿饭',
    category: 'meishi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20teriyaki%20chicken%20rice%20bowl%20on%20minimal%20ceramic%20plate%2C%20garnished%20with%20sesame%20and%20green%20onion%2C%20warm%20overhead%20kitchen%20lighting%2C%20wooden%20chopsticks%2C%20clean%20cream%20background&width=800&height=450&seq=video-thumb-09&orientation=landscape',
    duration: '04:10',
    views: 178000,
    author: '一人食日记',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20food%20blogger%20portrait%2C%20apron%2C%20warm%20genuine%20smile%2C%20studio%20lighting%2C%20cream%20background&width=120&height=120&seq=author-avatar-09&orientation=squarish',
    description: '一个人也要好好吃饭！这道照烧鸡腿饭做法简单、味道惊艳，是忙碌工作日的完美选择。酱汁配方是灵魂，一定要记下来哦！',
    featured: false,
  },
  {
    id: 10,
    title: '手机摄影秘籍｜用普通手机拍出大片感',
    category: 'chuangyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Smartphone%20photography%20setup%20on%20minimal%20desk%2C%20phone%20on%20tripod%2C%20camera%20lens%20attachment%2C%20natural%20light%20from%20window%2C%20warm%20cream%20tones%2C%20creative%20workspace%20aesthetic&width=800&height=450&seq=video-thumb-10&orientation=landscape',
    duration: '07:15',
    views: 234000,
    author: '光影捕手',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20photographer%20portrait%2C%20holding%20camera%2C%20artistic%20beard%2C%20warm%20studio%20lighting%2C%20cream%20background&width=120&height=120&seq=author-avatar-10&orientation=squarish',
    description: '别再羡慕别人的照片了！这期分享我用了三年的手机摄影心得，从构图、光影到后期调色，系统性地教你用手机拍出惊艳的照片。',
    featured: false,
  },
  {
    id: 11,
    title: '日本关西深度游｜京都奈良大阪全攻略',
    category: 'lvxing',
    thumbnail: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20temple%20in%20Kyoto%20with%20autumn%20maple%20leaves%2C%20wooden%20architecture%2C%20stone%20garden%2C%20warm%20golden%20sunlight%2C%20serene%20atmosphere%2C%20travel%20photography%20style&width=800&height=450&seq=video-thumb-11&orientation=landscape',
    duration: '12:30',
    views: 389000,
    author: '行走的咖啡',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20travel%20blogger%20portrait%2C%20casual%20stylish%20outfit%2C%20friendly%20expression%2C%20warm%20studio%20lighting%2C%20cream%20background&width=120&height=120&seq=author-avatar-02&orientation=squarish',
    description: '关西地区最全自由行攻略！从京都的古寺神社到奈良的小鹿，再到大阪的美食天堂，带你深度体验日本关西的文化与风情。',
    featured: false,
  },
  {
    id: 12,
    title: '零基础学电钢琴｜《卡农》简易版教学',
    category: 'yinyue',
    thumbnail: 'https://readdy.ai/api/search-image?query=Digital%20piano%20in%20minimal%20modern%20room%20with%20warm%20sunset%20light%2C%20music%20sheet%20on%20stand%2C%20cozy%20creative%20atmosphere%2C%20cream%20walls%2C%20artistic%20interior&width=800&height=450&seq=video-thumb-12&orientation=landscape',
    duration: '09:40',
    views: 156000,
    author: '音乐小教室',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20music%20teacher%20portrait%2C%20gentle%20smile%2C%20classical%20elegance%2C%20warm%20studio%20lighting%2C%20cream%20background&width=120&height=120&seq=author-avatar-12&orientation=squarish',
    description: '完全零基础也没关系！本期用最通俗易懂的方式教你弹奏《卡农》的简化版本。从识谱到双手配合，跟着学一定能弹出美妙的旋律。',
    featured: false,
  },
];

export const creators = [
  {
    name: '甜蜜厨房',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20chef%20portrait%2C%20warm%20smile%2C%20clean%20white%20chef%20apron%2C%20soft%20studio%20lighting%2C%20neutral%20cream%20background%2C%20professional%20headshot%20style&width=120&height=120&seq=author-avatar-01&orientation=squarish',
    followers: 1280000,
    description: '美食领域头部创作者，专注家常美食与创意料理',
  },
  {
    name: '行走的咖啡',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20travel%20blogger%20portrait%2C%20casual%20stylish%20outfit%2C%20friendly%20expression%2C%20warm%20studio%20lighting%2C%20cream%20background&width=120&height=120&seq=author-avatar-02&orientation=squarish',
    followers: 890000,
    description: '旅行达人，探索世界各地的咖啡馆与城市文化',
  },
  {
    name: '手账小仙女',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20artist%20portrait%2C%20gentle%20smile%2C%20pastel%20clothing%2C%20creative%20vibe%2C%20soft%20studio%20lighting%2C%20warm%20cream%20background&width=120&height=120&seq=author-avatar-03&orientation=squarish',
    followers: 756000,
    description: '手账达人，用创意排版记录生活的每一份美好',
  },
  {
    name: '吉他小王子',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20musician%20portrait%2C%20holding%20guitar%2C%20artistic%20look%2C%20warm%20studio%20lighting%2C%20cream%20background&width=120&height=120&seq=author-avatar-04&orientation=squarish',
    followers: 945000,
    description: '音乐才子，用吉他重新诠释经典与流行',
  },
  {
    name: '科技猎奇',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20tech%20reviewer%20portrait%2C%20smart%20casual%20look%2C%20friendly%20smile%2C%20warm%20studio%20lighting%2C%20cream%20background&width=120&height=120&seq=author-avatar-07&orientation=squarish',
    followers: 1100000,
    description: '科技前沿探索者，带你了解最新数码产品与AI技术',
  },
  {
    name: '时尚教主',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20female%20fashion%20stylist%20portrait%2C%20sophisticated%20look%2C%20warm%20smile%2C%20studio%20lighting%2C%20cream%20background&width=120&height=120&seq=author-avatar-08&orientation=squarish',
    followers: 678000,
    description: '时尚博主，分享实用穿搭技巧与潮流趋势',
  },
];

export const faqs = [
  {
    question: '蜜桃视频是什么？',
    answer: '蜜桃视频是一个精选短视频内容平台，汇聚海量优质视频资源，涵盖生活、美食、娱乐、创意等多元内容领域。我们致力于为内容创作者和视频爱好者打造优质的创作与观赏体验。',
  },
  {
    question: '如何在蜜桃视频上发布自己的作品？',
    answer: '注册成为蜜桃视频创作者后，点击右上角的"创作中心"按钮，即可上传您的短视频作品。我们支持多种视频格式，并提供丰富的编辑工具帮助您打造优质内容。',
  },
  {
    question: '蜜桃视频的内容审核标准是什么？',
    answer: '我们坚持"优质、健康、创新"的内容理念。所有上传内容需符合国家法律法规和社区规范，不得包含暴力、色情、侵权等违规内容。我们的审核团队会在24小时内完成内容审核。',
  },
  {
    question: '蜜桃视频如何保障创作者收益？',
    answer: '我们建立了完善的创作者激励机制，包括流量分成、品牌合作、打赏功能和创作基金等多种方式。优质创作者还可获得平台流量扶持和专属运营服务。',
  },
  {
    question: '蜜桃视频支持哪些设备观看？',
    answer: '蜜桃视频全面支持Web端、iOS和Android移动端，以及智能电视等大屏设备。您可以在任何设备上无缝切换，享受一致的观看体验。',
  },
  {
    question: '如何联系蜜桃视频的客服团队？',
    answer: '您可以通过以下方式联系我们：在线客服（工作日9:00-18:00）、邮箱support@mitaovideo.com，或关注我们的官方社交媒体账号获取最新资讯。',
  },
];